/* Cartec Essentials — winkelwagen-teller synchroniseren met externe cart-apps.
   De Horizon <cart-icon>-teller werkt zichzelf alleen bij op Horizon's eigen
   cart-events. Apps zoals UpCart/Bundler wijzigen de cart via de Ajax API maar
   vuren die events niet af -> de teller in de header loopt uit de pas.

   Deze bridge onderschept elke Ajax-cartmutatie (add/change/update/clear) en
   herberekent de teller uit /cart.js. Zo klopt "Winkelwagen (n)" altijd. */
(function () {
  /* --------------------------------------------------------------------
     UpCart opent alleen betrouwbaar bij een klik op het TEKST-element in de
     winkelwagen-knop, niet op de randen/het icoon/de teller (daar navigeert de
     link naar /cart). We vangen klikken op de hele knop af en sturen ze door
     naar de tekst, zodat de hele knop de UpCart-drawer opent.
     -------------------------------------------------------------------- */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.ce-header__cart');
      if (!btn) return;
      var label = btn.querySelector('.ce-header__cart-label');
      if (!label) return;
      // Echte tekst-klik: UpCart pakt 'm al -> niets doen.
      if (e.target === label || label.contains(e.target)) return;
      // Rand/icoon/teller: navigatie blokkeren en de klik doorsturen naar de tekst.
      e.preventDefault();
      label.click();
    },
    true
  );

  var timer = null;

  function applyCount(count) {
    var label = count > 0 ? (count < 100 ? String(count) : '99+') : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = label;
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', count === 0);
    });
  }

  function sync() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyCount(cart.item_count || 0); })
      .catch(function () {});
  }

  function scheduleSync() {
    clearTimeout(timer);
    // Kleine vertraging zodat Shopify de mutatie heeft verwerkt.
    timer = setTimeout(sync, 250);
  }

  function isCartMutation(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  // fetch onderscheppen
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var input = arguments[0];
      var url = (input && input.url) ? input.url : input;
      var p = origFetch.apply(this, arguments);
      if (isCartMutation(url)) { p.then(scheduleSync).catch(function () {}); }
      return p;
    };
  }

  // XMLHttpRequest onderscheppen
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ceCartUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this.__ceCartUrl)) {
      this.addEventListener('loadend', scheduleSync);
    }
    return origSend.apply(this, arguments);
  };
})();
